import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { Text, Toggletip } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { formatDeliveryDate } from "../../../../../utils/LineItems/utils/format-delivery-date.js";
/* empty css                        */
const DeliveryDateTime = ({ dateTime, locale }) => {
  const label = formatDeliveryDate(locale, dateTime);
  return /* @__PURE__ */ React.createElement("time", { dateTime }, label);
};
const DeliveryEstimation = ({
  tooltipId,
  labels,
  earliestDeliveryDate,
  latestDeliveryDate
}) => {
  const { locale } = useIntl();
  if (!earliestDeliveryDate) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "delivery-estimation" }, /* @__PURE__ */ React.createElement(Icon, { name: "parcel", width: 24, height: 24 }), /* @__PURE__ */ React.createElement(Text, { variant: "text-caption-head", className: "delivery-estimation__label" }, labels.label, " ", /* @__PURE__ */ React.createElement(DeliveryDateTime, { dateTime: earliestDeliveryDate, locale }), latestDeliveryDate && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", "-", " ", /* @__PURE__ */ React.createElement(DeliveryDateTime, { dateTime: latestDeliveryDate, locale }))), labels.tooltip && /* @__PURE__ */ React.createElement(
    Toggletip,
    {
      className: "delivery-estimation__tooltip",
      id: tooltipId,
      message: labels.tooltip,
      placement: "top",
      ariaLabel: labels.tooltip
    }
  ));
};
export {
  DeliveryEstimation
};
//# sourceMappingURL=DeliveryEstimation.js.map
